/**
 * Central app logger for payment/certificate flows.
 * Logs to console with [APP] tag for easy grep (e.g. grep '[APP]' in logs).
 * Optionally sends events to backend for server-side audit trail.
 */

const LOG_PREFIX = '[APP]';

function getApiBaseUrl() {
  try {
    if (typeof window === 'undefined') return '';
    if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
    const { hostname, port } = window.location || {};
    if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://10.25.30.30:8445';
    if (port === '8440') return `http://${hostname}:8445`;
    return '';
  } catch {
    return '';
  }
}

/**
 * Log an event (always to console; optionally to backend).
 * @param {string} event - Event name (e.g. payment_success, certificate_issued, certificate_failed)
 * @param {object} data - Optional payload (ref, clientId, error, etc.)
 * @param {string} tag - Optional tag (default: CHECKOUT)
 */
export function logEvent(event, data = {}, tag = 'CHECKOUT') {
  const ts = new Date().toISOString();
  const payload = { event, ...data };
  const line = [LOG_PREFIX, `tag=${tag}`, `event=${event}`, `ts=${ts}`];
  if (data && typeof data === 'object') {
    Object.entries(data).forEach(([k, v]) => {
      if (v != null && typeof v !== 'function')
        line.push(`${k}=${typeof v === 'object' ? JSON.stringify(v) : String(v)}`);
    });
  }
  console.log(line.join(' '));

  // Optional: send to backend for server-side trail (non-blocking)
  const base = getApiBaseUrl();
  if (base && typeof fetch === 'function') {
    fetch(`${base}/api/log-event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tag, event, data: payload, ts })
    }).catch(() => {}); // ignore network errors for logging
  }
}

export default { logEvent };
